"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const http = require("http");
const notify = ({ key, title, description }) => __awaiter(this, void 0, void 0, function* () {
    const host = 'api.pling.dev';
    // const host = 'localhost';
    const path = '/logs';
    const method = 'POST';
    const body = JSON.stringify({ title, description });
    const headers = {
        'Content-Type': 'application/json',
        'x-api-key': key,
    };
    // Browserify or webpack defines a process.browser
    if (process.browser) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`https://${host}${path}`, {
                method,
                headers,
                body,
            });
            if (response.status === 201) {
                return resolve();
            }
            return reject();
        }));
    }
    else {
        const options = {
            host,
            path,
            method,
            headers,
        };
        return new Promise((resolve, reject) => {
            const req = http.request(options, res => {
                // The 'end' event will not be emitted unless the data is completely consumed. see: https://nodejs.org/api/stream.html#stream_class_stream_readable
                res.on('data', () => { });
                res.on('end', () => {
                    if (res.statusCode && res.statusCode >= 200 && res.statusCode <= 299) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                });
            });
            req.on('error', reject);
            req.write(body);
            req.end();
        });
    }
});
module.exports = notify;
